import { render } from "./ArtworkModal.vue?vue&type=template&id=78deafd0&scoped=true"
import script from "./ArtworkModal.vue?vue&type=script&lang=js"
export * from "./ArtworkModal.vue?vue&type=script&lang=js"

import "./ArtworkModal.vue?vue&type=style&index=0&id=78deafd0&scoped=true&lang=css"

import exportComponent from "/home/mat/gptcube/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78deafd0"]])

export default __exports__